import { render } from "./PurchaseConfirmation.vue?vue&type=template&id=0b2b1e1f&scoped=true"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=js"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=js"

import "./PurchaseConfirmation.vue?vue&type=style&index=0&id=0b2b1e1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2b1e1f"]])

export default __exports__